/** @jsx jsx */
import { jsx } from '@emotion/react';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Label from 'react-bootstrap/lib/Label';
import get from 'lodash/get';
import keys from 'lodash/keys';
import omit from 'lodash/omit';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';

import {
  selectAnswerByElementName,
  selectElementByName,
  selectPageById,
} from '../../redux/selectors';
import { PAGES__SHAPE_ITEM } from '../../redux/constants';

import css from './dynamic-text.css';

const splitIntoSegments = (input) => input.split(/(#[a-zA-Z_$]+[0-9a-zA-Z_$]+\b)/gi);

const getTag = (segment) => segment.slice(1);

export const findTags = (input) =>
  splitIntoSegments(input)
    .filter((segment, key) => key % 2)
    .map(getTag);

export const validateSegment = (element, a, b) => {
  if (!element) return "Can't find the refrence.";
  if (b.position > a.position) {
    return 'Target element is behind this slide, consider sorting.';
  }
  return null;
};

const propTypes = {
  addNewLine: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  element: PropTypes.node,
  selectAnswerByElementName: PropTypes.func.isRequired,
  selectElementByName: PropTypes.func.isRequired,
  selectPageById: PropTypes.func.isRequired,
  children: PropTypes.node,
  multiline: PropTypes.bool,
};

class DynamicText extends PureComponent {
  static propTypes = propTypes;
  static contextTypes = {
    editable: PropTypes.bool,
    page: PAGES__SHAPE_ITEM,
  };
  static defaultProps = {
    addNewLine: false,
    children: '',
    element: 'div',
    multiline: false,
  };
  children = () => {
    const { children } = this.props;
    const segments = splitIntoSegments(children);
    return segments.map((segment, key) =>
      key % 2 ? this.renderSegment(segment, key) : <span key={segment}>{segment}</span>,
    );
  };
  validateClient = (answer) => {
    if (!answer) return "Can't find answer.";
    return null;
  };
  validate(answer, element) {
    return this.context.editable
      ? validateSegment(
          element,
          this.context.page,
          this.props.selectPageById(get(element, 'pageId')),
        )
      : this.validateClient(answer);
  }
  renderSegment = (segment, key) => {
    const elementName = getTag(segment);
    const answer = this.props.selectAnswerByElementName(elementName);
    const element = this.props.selectElementByName(elementName);
    const value = get(answer, 'value', segment);
    const error = this.validate(answer, element);
    return error ? (
      <OverlayTrigger
        key={key}
        placement="bottom"
        overlay={<Tooltip id={`dynamic-text${key}`}>{error}</Tooltip>}
      >
        <Label bsStyle="danger" key={key}>
          {value}
        </Label>
      </OverlayTrigger>
    ) : (
      <span key={key}>{value}</span>
    );
  };
  render() {
    if (!this.props.children) return null;
    const { addNewLine, element: Element, multiline } = this.props;
    return (
      <Element {...omit(this.props, keys(propTypes))} css={css({ addNewLine, multiline })}>
        {this.children()}
      </Element>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  selectAnswerByElementName: (elementName) => selectAnswerByElementName(state, elementName),
  selectElementByName: (elementName) => selectElementByName(state, elementName),
  selectPageById: (pageId) => selectPageById(state, pageId),
  ...ownProps,
});

export default connect(mapStateToProps, null)(DynamicText);
